import { useQuery } from "@tanstack/react-query";

import { supabase } from "@/shared/lib/supabase";

interface NotificationFlags {
  notificationsEnabled: boolean;
  elayneEmailBypassEnabled: boolean;
}

export function useNotificationFlags() {
  const { data: flags, error } = useQuery({
    queryKey: ["notification-flags"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("feature_flags")
        .select("name, enabled")
        .in("name", ["notifications_enabled", "elayne_email_bypass_enabled"]);

      if (error) throw error;

      const flagMap = Object.fromEntries((data ?? []).map((f) => [f.name, f.enabled]));

      return {
        notificationsEnabled: flagMap["notifications_enabled"] ?? false,
        elayneEmailBypassEnabled: flagMap["elayne_email_bypass_enabled"] ?? false,
      } satisfies NotificationFlags;
    },
    staleTime: 30_000,
  });

  if (error) {
    console.error("Failed to load notification flags:", error);
  }

  const canSendNotification = (email?: string | null): boolean => {
    if (!flags) return false;
    if (!flags.notificationsEnabled) return false;

    const isElayneEmail = email?.endsWith("@elayne.com") ?? false;
    if (isElayneEmail && !flags.elayneEmailBypassEnabled) return false;

    return true;
  };

  return { canSendNotification, flags };
}
